import styled, {css} from 'styled-components';
import {DEVICE, MainLoader} from '@chekin/guestapp-ui-kit';
import {Button} from '@chekinapp/ui';

export const Wrapper = styled.div<{$isLoading?: boolean}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 852px;
  width: 100%;
  gap: 24px 48px;
  transition: opacity 0.3s ease-in-out;
  container-type: inline-size;

  ${({$isLoading}) =>
    $isLoading &&
    css`
      opacity: 0.5;
    `}
`;

export const ContentCart = styled.div<{$isInitialized?: boolean}>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${({$isInitialized}) =>
    $isInitialized &&
    css`
      opacity: 1;
    `}
`;

export const Divider = styled.div`
  display: none;
  width: 1px;
  background: #00000017;
  align-self: stretch;

  @container (min-width: 751px) {
    display: block;
  }
`;

export const Summary = styled.div`
  padding: 16px 24px 24px;
  background: ${props => props.theme.colors.branding.backgroundSecondary};
  border-radius: 16px;
  max-width: 327px;
  width: 100%;

  @media (min-width: ${DEVICE.laptop}) {
    padding: 16px 24px 24px;
    background: ${props => props.theme.colors.branding.backgroundSecondary};
    border-radius: 16px;
  }
`;

export const PaymentSummaryItemWrapper = styled.div`
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const PaymentSummaryItemTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    margin: 0;
    font-weight: 400;
    font-size: 14px;
    color: ${props => props.theme.colors.branding.fontPrimary};
  }
`;
export const PaymentSummaryItemDescription = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;

  & > p {
    font-weight: 400;
    font-size: 12px;
    margin: 0;
    color: ${props => props.theme.colors.branding.fontSecondary};
  }
  path {
    stroke: ${props => props.theme.colors.branding.fontSecondary};
  }

  circle {
    fill: ${props => props.theme.colors.branding.fontSecondary};
  }
`;

export const TotalPayment = styled.div<{$isEmpty: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -8px;
  padding-bottom: 16px;
  font-size: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  color: ${props => props.theme.colors.branding.fontPrimary};

  ${({$isEmpty}) =>
    $isEmpty &&
    css`
      border: none;
    `}

  &:first-child {
    font-weight: 600;
  }

  &:last-child {
    font-weight: 700;
    text-align: right;
    border-bottom: none;
    padding-bottom: 0;
    margin-top: 8px;
  }
`;

export const ConfirmButton = styled(Button)`
  width: 100%;
  margin: 24px auto;

  @media (min-width: ${DEVICE.laptop}) {
    max-width: 295px;
    margin: 48px auto;
  }

  .buttonLabel {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Container = styled.div<{$isInitialized?: boolean}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;

  ${props =>
    props.$isInitialized &&
    css`
      opacity: 1;
    `}
`;

export const StyledLoader = styled(MainLoader)`
  margin: 100px auto 0;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
`;

export const Hr = styled.div`
  background: rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 1px;
`;
